import { produce } from "immer";
import { useState } from "react";
import { mapEdgesToNodes } from "../../../../../base/utils";
import { useAttributesQuery } from "../../../../../saleor/api";
import { CategoryFilterAttributesTransformer } from "../../../../../services/objectTransformer/categories";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { _SET_ATTRIBUTE } from "../../../../../store/actions/attribute_actions";

const useFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const categories = searchParams.get("cat")?.split(",") || null;  const [filter_list, set_filter_list] = useState([]);
  const dispatch = useDispatch();
  const current_filters = filter_list.map((filter) => {
    if (searchParams.has(filter.slug)) {
      return {
        slug: filter.slug,
        values: searchParams.get(filter.slug).split(","),
      };
    }
  });
  const { channel } = useSelector((state) => state.Login);

  const { data: filterAttributes, error: errorAttributes } = useAttributesQuery(
    {
      variables: {
        channel,
        filter: {
          ...(categories && { inCategory: categories[categories.length - 1] }),        },
      },
      onCompleted: (attributesData) => {
        const attributesNodes = mapEdgesToNodes(
          attributesData?.attributes?.edges
        );

        let new_filters = attributesNodes.map((attributesNode) =>
          CategoryFilterAttributesTransformer(attributesNode)
        );

        const defaultSortId = attributesNodes.find(
          (attributeNode) => attributeNode.slug === "priority"
        )?.id;

        defaultSortId &&
          setSearchParams(
            (prev) => {
              prev.set("init", defaultSortId);
              return prev;
            },
            { replace: true }
          );

        new_filters = new_filters.filter(Boolean).map((filter) => {
          let slug_list = filter.list;
          if (searchParams.has(filter.slug) && filter.list.length > 0) {
            let searchParamList = searchParams.get(filter.slug).split(",");
            slug_list = filter.list.map((slug_item) => ({
              ...slug_item,
              active: searchParamList.includes(slug_item.slug) ? true : false,
            }));
          }
          return {
            ...filter,
            list: slug_list,
          };
        });
        if (new_filters.length > 0) {
          dispatch(_SET_ATTRIBUTE(new_filters.map((att) => att.slug)));
        }
        set_filter_list(new_filters);
      },
      skip: filter_list.length,
    }
  );

  const clear_filter = () => {
    set_filter_list(
      mapEdgesToNodes(
        filterAttributes?.attributes?.edges,
        CategoryFilterAttributesTransformer
      )
    );
    setSearchParams((prev) => {
      filter_list.forEach((filter) => {
        prev.delete(filter.slug);
      });
      return prev;
    });
  };

  const getFilterCategoryQueryParams = (filter_list) => {
    const new_filter_list_items = filter_list.map(({ slug, list }) => ({
      slug,
      values: list
        .map((item) => item)
        .filter((item) => item.active)
        .map((item) => item.slug),
    }));
    const new_obj = {};

    new_filter_list_items
      .filter((new_item) => new_item.values.length)
      .forEach(({ slug, values }) => {
        new_obj[slug] = values;
      });
    return new_obj;
  };

  const submit_filter = () => {
    let filter_slugs_obj = getFilterCategoryQueryParams(filter_list);
    setSearchParams((prev) => {
      filter_list.forEach((filter) => {
        prev.delete(filter.slug);
      });
    });

    if (!_.isEmpty(filter_slugs_obj)) {
      setSearchParams((prev) => {
        Object.entries(filter_slugs_obj).forEach(([key, value]) => {
          prev.set(key, value.join(","));
        });
        return prev;
      });
    }
  };

  const checkbox_change = (filter_item_index, sub_item_index, value) => {
    set_filter_list(
      produce((draft) => {
        draft[filter_item_index].list[sub_item_index].active = value;
      })
    );
  }; // eslint-disable-next-line

  const delete_filter = (filter_item_index, value) => {
    const currentAttributeSlug = filter_list[filter_item_index].slug;
    const sub_item_index = filter_list[filter_item_index].list.findIndex(
      (list_item) => list_item.slug === value
    );
    checkbox_change(filter_item_index, sub_item_index, false);
    setSearchParams((prev) => {
      let slugList = prev.get(currentAttributeSlug).split(",");
      slugList = slugList.filter((slug) => slug !== value);
      if (slugList.length) {
        prev.set(currentAttributeSlug, slugList.join(","));
      } else {
        prev.delete(currentAttributeSlug);
      }
      return prev;
    });
  };

  return [
    filter_list,
    checkbox_change,
    submit_filter,
    current_filters,
    delete_filter,
    clear_filter,
    errorAttributes,
  ];
};

export default useFilter;
